import React from 'react';
import { Card, CardProps } from '@mui/material';
import { useTheme } from '../../hooks/ThemeProvider';
import './GlassmorphicCard.scss';

interface GlassmorphicCardProps extends CardProps {
  opacity?: number;
  blur?: number;
  className?: string;
}

export const GlassmorphicCard: React.FC<GlassmorphicCardProps> = ({
  opacity = 0.7,
  blur = 10,
  className = '',
  children,
  ...rest
}) => {
  const { isDarkMode } = useTheme();

  return (
    <Card
      className={`glassmorphic-card ${isDarkMode ? 'glassmorphic-card--dark' : 'glassmorphic-card--light'} ${className}`}
      style={{
        '--opacity': opacity,
        '--blur': `${blur}px`,
      } as React.CSSProperties}
      {...rest}
    >
      {children}
    </Card>
  );
};
